
import axios from "axios";
import { store } from "store";
import { configUpdate } from "store/config";
import { OutputBaseProps } from "utils/types/API";
import { ConfigItemProps, ServicePriceProps } from ".";
import { aboutUpdate } from "store/about";
import { missionVisionUpdate } from "store/mision-vision";
import { servicePriceUpdate } from "store/service-price";

type ApiConfigOutputProps = OutputBaseProps<{ item: ConfigItemProps }>

export const apiGetConfig = async () => {
    const res = (await axios.get<ApiConfigOutputProps>("/api/config"))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(configUpdate(res.data.item));
    }
    return res;
};


type ApiAboutOutputProps = OutputBaseProps<{ item: { title: string; content: string } }>
export const apiGetAbout = async () => {
    const res = (await axios.get<ApiAboutOutputProps>("/api/about"))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(aboutUpdate(res.data.item));
    }
    return res;
};

type ApiMissionVisionOutputProps = OutputBaseProps<{ item: { thumbnailUrl?: string; title: string; subTitle?: string; content: string } }>
export const apiGetMissionVision = async () => {
    const res = (await axios.get<ApiMissionVisionOutputProps>("/api/mission-vision"))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(missionVisionUpdate(res.data.item));
    }
    return res;
};


type ApiServicePriceOutputProps = OutputBaseProps<{
    item: ServicePriceProps
}>
export const apiServicePrice = async () => {
    const res = (await axios.get<ApiServicePriceOutputProps>("/api/service-price"))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(servicePriceUpdate(res.data.item));
    }
    return res;
};